import React, { useEffect } from 'react';
import { XIcon } from 'lucide-react';
interface LegalModalProps {
  isOpen: boolean;
  onClose: () => void;
  title: string;
  children: React.ReactNode;
}
export function LegalModal({
  isOpen,
  onClose,
  title,
  children
}: LegalModalProps) {
  useEffect(() => {
    if (isOpen) {
      document.body.style.overflow = 'hidden';
    } else {
      document.body.style.overflow = '';
    }
    return () => {
      document.body.style.overflow = '';
    };
  }, [isOpen]);
  if (!isOpen) return null;
  return <div className="fixed inset-0 z-50 flex items-center justify-center p-4" role="dialog" aria-modal="true" aria-label={title} data-id="element-201">
      {/* Backdrop */}
      <div className="absolute inset-0 bg-black/70 backdrop-blur-sm" onClick={onClose} data-id="element-202" />

      {/* Modal */}
      <div className="relative bg-navy-light border border-white/10 rounded-2xl w-full max-w-2xl max-h-[80vh] flex flex-col shadow-2xl" data-id="element-203">
        {/* Header */}
        <div className="flex items-center justify-between px-6 py-4 border-b border-white/10" data-id="element-204">
          <h2 className="text-xl font-bold text-white font-heading" data-id="element-205">{title}</h2>
          <button onClick={onClose} className="p-2 rounded-lg text-gray-400 hover:text-white hover:bg-white/10 transition-colors" aria-label="Cerrar" data-id="element-206">
            <XIcon className="w-5 h-5" data-id="element-207" />
          </button>
        </div>

        {/* Content */}
        <div className="px-6 py-6 overflow-y-auto text-gray-300 text-base leading-relaxed space-y-4" data-id="element-208">
          {children}
        </div>
      </div>
    </div>;
}